//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import assetUrl from "../js/components/assetUrl";

export default {
  props: {
    activePoint: {
      required: true
    },
    imgDebug: {
      type: Function,
      required: true
    },
    getCities: {
      type: Function,
      required: true
    },
    typeMap: {
      type: String,
      required: false
    },
  },
  computed: {
    pointStyle() {
      return (point) => {
        return {
          left: `${point.percentCoordinate.x}%`,
          top: `${point.percentCoordinate.y}%`,
        }
      }
    },
    mapUrl() {
      if (this.typeMap) {
        return assetUrl(`../img/${this.typeMap}.png`);
      } else {
        if (this.activePoint && this.activePoint.isWorldMap) {
          return assetUrl('../img/mapWorld.png');
        }
        return assetUrl('../img/n/map.svg');
      }
    }
  }
}
